<script setup>
import modalTabsTemplate from "./modal-tabs-template.vue";
defineProps(['data']);
</script>

<template>
	<div class="modal-header">
		<button type="button" class="close btn-close" @click.prevent="data.onClose()"><span>&times;</span></button>
		<a href="#" class="btn-close-mobile" @click.prevent="data.onClose()"><i class="icon-soar-menu-left"></i></a>
		<template v-if="data.title">
			<h3 v-html="data.title" class="form-title" :class="{'revamped-ui': model.modalRevampedUI}"></h3>
		</template>
		<template v-else-if="data.titleLabelData">
			<h3 v-lang="model.redeemLangObj(data.titleLabelData)" class="form-title" :class="{'revamped-ui': model.modalRevampedUI}"></h3>
		</template>
		<template v-if="Boolean(data.scallablePage) && !data.tabsInner">
			<modal-tabs-template :pages="data.pages"></modal-tabs-template>
		</template>
	</div>
</template>